import * as Luxon from 'luxon';

export const TIME_ZONE = 'Australia/Sydney';

Luxon.Settings.defaultZone = TIME_ZONE;

export const luxonLocal = Luxon;
